module.exports = __webpack_public_path__ + "static/media/present-box.a08e71d1.png";